export const SET_TP_ACCOUNT_FILTERS = 'SET_TP_ACCOUNT_FILTERS';
export const setTPAccountFilters = (filterData: any) => ({
  type: SET_TP_ACCOUNT_FILTERS,
  payload: filterData,
});

const initialState: any = {};

interface Action {
  type: string;
  payload: any;
}

const tpAccountFilterReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_TP_ACCOUNT_FILTERS:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
export default tpAccountFilterReducer;
